<template>
  <div class="profitDetail">
    <div class="carInfo">
      <div class="selectMonth" @click="setTime">{{currentDateShow}} <i class="iconfont icon-triangle-down"></i></div>
    </div>
    <div class="profitInfo">
      <div class="content">
        <div class="top">
          <span class="bold">{{IncomeInfo.Total}}.00</span>
          <span>本月收益合计（元）</span>
        </div>
        <div class="bottom">
          <div class="item">
            <span>租金</span>
            <span>{{IncomeInfo.Rent}}</span>
          </div>
          <div class="item">
            <span>奖励金</span>
            <span>{{IncomeInfo.Bonus}}</span>
          </div>
          <div class="item">
            <span>其他</span>
            <span>{{IncomeInfo.Other}}</span>
          </div>
        </div>
      </div>
    </div>
    <datetimeMini :start='startDate' :current='current' :type='timeType' v-if="timeType > 0" :onCancel="onCancel" :onConfirm="onConfirm"></datetimeMini>
  </div>
</template>

<script>
  import {
    getOnlineDate,
    getIncomeInfo
  } from "@/utils/api";
  import {getNowFormatDate,setYYYY,getMonth}from '@/utils/formatDate'

  import datetimeMini from '@/components/datetimeMini/datetime.vue'
    export default {
      name: "profitDetail",
      data: function () {
        return {
          timeType:0,//0关闭 1显示
          IncomeInfo:{},
          startDate:'',
          currentDateShow:'',
          current:''
        };
      },
      components: {
        datetimeMini
      },
      created() {
        let time = getNowFormatDate();
        let month = getMonth(time) + 1;
        month = (month<10 ? "0"+month:month);
        this.currentDateShow = setYYYY(time) + "年" + month + "月";
        this.current = time;
      },
      mounted() {
        this.getOnlineDate();
      },
      methods: {
        //获取收益详情
        async getIncomeInfo(start){
          let res = await getIncomeInfo({
            data:{
              month:start
            }
          });
          if(res.Code == 100){
            this.IncomeInfo = res.Data;
          }
        },
        //获取上线开始时间
        async getOnlineDate(){
          let res = await getOnlineDate();
          if(res.Code == 100){
            this.startDate = res.Data.replace('T',' ');
            this.getIncomeInfo(this.startDate);
          }
        },
        setTime(){
          this.timeType = 1;
        },
        onCancel(){
          this.timeType = 0;
        },
        onConfirm(start){
          this.getIncomeInfo(start);
        }
      }
    }
</script>

<style  scoped lang="scss" type="text/scss">
.profitDetail{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 110px;
  box-sizing: border-box;
  background: url("~@/assets/images/user/walletBg.png") no-repeat 0 0;
  background-size: 100% 559px;
  .carInfo{
    padding-top: 20px;
    box-sizing: border-box;
    height: 453px;
    text-align: center;
    font-size: 32px;
    color: #fff;
    span{
      display: block;
    }
    .selectMonth{
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      .iconfont{
        margin-top: 10px;
      }
    }
  }
  .profitInfo{
    position: absolute;
    background-color: #fff;
    width: 100%;
    top: 480px;
    bottom: 0px;
    left: 0px;
    .content{
      position: relative;
      bottom: 260px;
      left:23px;
      width: 700px;
      height: 544px;
      .top{
        display: flex;
        flex-direction: column;
        padding: 60px 60px 0 60px;
        box-sizing: border-box;
        height: 208px;
        background: #fff;
        color: #9F9F9F;
        font-size: 24px;
        border-radius: 10px;
        text-align: center;
        box-shadow:0px 6px 15px #ccc;
        -webkit-box-shadow: 0px 6px 15px #ccc;
        .bold{
          display: flex;
          justify-content: center;
          color: #027FFF;
          font-size: 46px;
        }
      }
      .bottom{
        padding: 0 45px;
        box-sizing: border-box;
        height: 336px;
        background: #fff;
        border-radius: 20px;
        box-shadow:-3px 6px 15px #ccc;
        -webkit-box-shadow: -3px 6px 15px #ccc;
        .item{
          display: flex;
          justify-content: space-between;
          padding: 50px 0;
          box-sizing: border-box;
          height: 80px;
          font-size: 28px;
          &:first-child{
            border-top:2px dashed #9f9f9f
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/car/profitDetail.vue